import { render, staticRenderFns } from "./OngoingScreeningMenu.vue?vue&type=template&id=77f9eae4&scoped=true&"
import script from "./OngoingScreeningMenu.vue?vue&type=script&lang=js&"
export * from "./OngoingScreeningMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f9eae4",
  null
  
)

export default component.exports